import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { NumericRangeStepWidth } from "./NumericRangeStepWidth";
import { NumericRangeText } from "./NumericRangeText";
/**
 * We currently do not indicate min or max inclusiveness
 * @param attribute
 * @returns
 */
export function NumericRange(props) {
    const rangeText = _jsx(NumericRangeText, Object.assign({}, props));
    const stepWidth = _jsx(NumericRangeStepWidth, Object.assign({}, props));
    return (_jsxs(Fragment, { children: [rangeText, " ", stepWidth] }));
}
//# sourceMappingURL=NumericRange.js.map